
function GenreList(params) {
    const genres = params.genres || [];
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {genres.map((g, i) => (
                <span key={i} style={{
                    fontSize: '10px',
                    backgroundColor: '#eff6ff',
                    color: '#1e40af',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    border: '1px solid #dbeafe'
                }}>
                    {g}
                </span>
            ))}
        </div>
    );
}

export default GenreList;